import React, { useState } from 'react';
import { Sparkles, FolderTree, Image } from 'lucide-react';
import { RelicsHeroManager } from './RelicsHeroManager';
import { RelicsCategoriesManager } from './RelicsCategoriesManager';
import { RelicsCardsManager } from './RelicsCardsManager';

export const RelicsContentDashboard = () => {
  const [activeTab, setActiveTab] = useState('hero');

  const tabs = [
    { id: 'hero', label: 'Hero Section', icon: Sparkles },
    { id: 'categories', label: 'Categories', icon: FolderTree },
    { id: 'cards', label: 'Cards', icon: Image }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'hero':
        return <RelicsHeroManager />;
      case 'categories':
        return <RelicsCategoriesManager />;
      case 'cards':
        return <RelicsCardsManager />;
      default:
        return <RelicsHeroManager />;
    }
  };

  return (
    <div>
      <div className="border-b bg-white">
        <div className="flex space-x-1 px-6">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-4 py-3 border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? 'border-orange-500 text-orange-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="font-medium">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="bg-gray-50 min-h-screen">
        {renderContent()}
      </div>
    </div>
  );
};
